// extracted by mini-css-extract-plugin
export default {"eachTestimonial":"TestimonialSection_eachTestimonial__SlzDO","style":"TestimonialSection_style__gvwAe"};